import { render, staticRenderFns } from "./phase-groups-table.vue?vue&type=template&id=5793473d&scoped=true"
import script from "./phase-groups-table.vue?vue&type=script&lang=js"
export * from "./phase-groups-table.vue?vue&type=script&lang=js"
import style0 from "./phase-groups-table.vue?vue&type=style&index=0&id=5793473d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5793473d",
  null
  
)

export default component.exports